var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.monthlyshort
    ? _c("div", { staticClass: "col-md-12" }, [
        _vm._m(0),
        _c("div", { staticClass: "ml-10" }, [
          _c("h5", [_vm._v("Text Group 1: Free text")]),
          _c(
            "table",
            { staticClass: "table table-responsive table-borderless" },
            [
              _c("tr", [
                _c("td", [_vm._v("Text content")]),
                _c("td", { attrs: { colspan: "5" } }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.monthlyshort.text1_content,
                        expression: "monthlyshort.text1_content",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      name: "text1_content",
                      "width-540px": "",
                      disabled: _vm.disabled,
                    },
                    domProps: { value: _vm.monthlyshort.text1_content },
                    on: {
                      change: function ($event) {
                        return _vm.update($event)
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.monthlyshort,
                          "text1_content",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "mx-5" }, [
      _c("h4", { staticClass: "mb-0" }, [_vm._v("Text area")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }